import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { BossItem } from './models';
import { BossActions } from './store/actions';
import {
  selectIsError,
  selectIsLoading,
  selectReports,
} from './store/selectors';
import { BossState } from './store/state';

@Injectable()
export class BossStateService {
  constructor(private readonly store: Store<BossState>) {}

  public loadReports() {
    this.store.dispatch(BossActions.GetItems.request());
  }

  public refreshReport(item: BossItem) {
    this.store.dispatch(BossActions.Refresh.request({ item }));
  }

  public downloadReport(item: BossItem) {
    this.store.dispatch(BossActions.Download.request({ item }));
  }

  public selectBossReports(): Observable<BossItem[]> {
    return this.store.pipe(select(selectReports));
  }

  public selectIsLoading(): Observable<boolean> {
    return this.store.pipe(select(selectIsLoading));
  }

  public selectIsError(): Observable<string> {
    return this.store.pipe(select(selectIsError));
  }
}
